import React from 'react';
import '../styles/About.css';

function About({ language }) {
  return (
    <section id="about" className="section bg-light">
      <div className="container">
        <h2>
          <span lang="en">About Nexofortis</span>
          <span lang="fr">À propos de Nexofortis</span>
        </h2>

        <p className="lead">
          <span lang="en">
            Founded in June 2025, Nexofortis specializes in system integration, data integration, automation, and AI-driven solutions.
            We deliver cutting-edge technologies to streamline processes, enhance efficiency, and transform digital operations.
          </span>
          <span lang="fr">
            Fondée en juin 2025, Nexofortis est spécialisée dans l’intégration de systèmes, l’intégration de données, l’automatisation et les solutions basées sur l’intelligence artificielle.
            Nous proposons des technologies de pointe pour optimiser les processus, améliorer l’efficacité et transformer les opérations digitales.
          </span>
        </p>
<div className="stats-grid">
  <div className="stat-card">
    <div className="stat-number">2025</div>
    <p className="stat-label">
      <span lang="en">Founded to deliver high-quality integrations with expert precision</span>
      <span lang="fr">Fondée pour fournir des intégrations de haute qualité avec une précision experte</span>
    </p>
  </div>

  <div className="stat-card">
    <div className="stat-number">10+</div>
    <p className="stat-label">
      <span lang="en">Years of combined experience in advanced data integration, automation, and AI-driven solutions.</span>
      <span lang="fr">Des années d’expérience cumulée en intégration avancée des données, en automatisation et en solutions basées sur l’intelligence artificielle.</span>
    </p>
  </div>

  {/* 🌍 New card */}
  <div className="stat-card">
    <div className="stat-number">EU / AFR</div>
    <p className="stat-label">
      <span lang="en">Operating from Portugal and Tunisia, delivering agile and high-value consulting services</span>
      <span lang="fr">Implantés au Portugal et en Tunisie, nous proposons des services de conseil agiles et à forte valeur ajoutée</span>
    </p>
  </div>
</div>
      </div>
    </section>
  );
}

export default About;
